import React from 'react';

/**
 * Read-only, non-removable chips for the auto-included email recipients
 * (requestor + chain approvers). Display only — these are never part of the
 * submit payload; the server force-includes them.
 *
 * `recipients` is a list of { label, role } where `role` is an optional
 * translated suffix (e.g. "requestor", "approver") shown in brackets.
 */
export default function LockedRecipientChips({ recipients }) {
    if (!recipients || recipients.length === 0) {
        return null;
    }

    return (
        <div className="tw-flex tw-flex-wrap tw-gap-1.5">
            {recipients.map((recipient, index) => (
                <span
                    key={index}
                    className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-0.5 tw-rounded-full tw-text-xs tw-font-medium tw-bg-charcoal-15 tw-text-charcoal tw-cursor-default"
                >
                    <span>
                        {recipient.label}
                        {recipient.role ? ` (${recipient.role})` : ''}
                    </span>
                    <span className="tw-text-charcoal-50" aria-hidden="true">
                        🔒
                    </span>
                </span>
            ))}
        </div>
    );
}
